import { Component, ElementRef, EventEmitter, OnInit, Input, Output } from '@angular/core';

// ionic
import { ModalController } from '@ionic/angular';

// rxjs
import { Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";

// other libraries
import { TranslateService } from "@ngx-translate/core";

// helpers
import { getHumanReadableFilesize } from "../../helpers/file";

// providers
import { PlatformService } from "../../services/platform.service";

// models
import { UploadedFile } from "../../models/uploaded-file";

// config
import { environment } from "../../../environments/environment";

@Component({
    selector: 'file-preview',
    templateUrl: './file-preview.component.html',
    styleUrls: ['./file-preview.component.scss'],
})
export class FilePreviewComponent implements OnInit {

    /**
     * message object
     *
     * @type UploadedFile
     */
    @Input() file: UploadedFile;

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * selected language
     *
     * @type string
     */
    public userLang: string;

    /**
     * user token for appointment download
     *
     * @type string
     */
    public userToken: string;

    /**
     * env configuration
     */
    public env = environment;

    /**
     * is file pdf?
     */
    public pdf: boolean = false;

    constructor(
        public translate: TranslateService,
        public plt: PlatformService,
        public modalController: ModalController
    ) {
        this.userLang = this.translate.currentLang;
        this.userToken = localStorage.getItem('token');
    }

    ngOnInit() {
        this.pdf = this.isPdf();
        // encode url for PDFJS viewer if file is PDF
        if (this.pdf) {
            this.file.file_url = encodeURIComponent(this.file.file_url);
        }
    }

    /**
     * determine if the file is pdf or not
     */
    private isPdf() {
        if (!this.file.name) {
            return false;
        }

        let ext = this.file.name.split('.').pop();
        return ['pdf'].indexOf(ext) !== -1;
    }

    public getHumanReadableFilesize(size, decimals = 2) {
        return getHumanReadableFilesize(size, decimals);
    }

    /**
     * close modal window
     *
     */
    public backClicked() {
        this.modalController.dismiss({
            action: 'close'
        });
    }
}
